export default __webpack_public_path__ + "static/media/400.60c75bf4.png";